import { useQuery } from 'react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';

import { getUserLicensesWithAttributes } from 'services/userLicensesWithAttributes/userLicensesWithAttributes';
import { GlobalStoreInterface } from 'interface/globalStore';

const QUERY_KEY = 'userLicensesWithAttributes';

export const useGetUserLicensesWithAttributes = () => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useQuery(
    [QUERY_KEY],
    () => getUserLicensesWithAttributes(sso, corpAccountNumber),
    {
      enabled: Boolean(sso && corpAccountNumber),
      retry: 1,
      refetchOnWindowFocus: false,
    },
  );
};
